import { render, staticRenderFns } from "./RestorePlant.vue?vue&type=template&id=022e974b&scoped=true&"
import script from "./RestorePlant.vue?vue&type=script&lang=js&"
export * from "./RestorePlant.vue?vue&type=script&lang=js&"
import style0 from "./RestorePlant.vue?vue&type=style&index=0&id=022e974b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e974b",
  null
  
)

export default component.exports